import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageInfraComponent } from './page.infra/page.infra.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalTicketingListComponent } from './portal.ticketing.list/portal.ticketing.list.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageTicketsGItemComponent } from './page.tickets.g.item/page.tickets.g.item.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalTicketingCreateComponent } from './portal.ticketing.create/portal.ticketing.create.component';
import { PageTicketsItemComponent } from './page.tickets.item/page.tickets.item.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageTicketsComponent } from './page.tickets/page.tickets.component';
import { PageTicketDesignsComponent } from './page.ticket.designs/page.ticket.designs.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageTicketsCreateComponent } from './page.tickets.create/page.tickets.create.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageTicketsGComponent } from './page.tickets.g/page.tickets.g.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalTicketingDetailComponent } from './portal.ticketing.detail/portal.ticketing.detail.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageInfraComponent,
        LayoutEmptyComponent,
        PortalTicketingListComponent,
        PageMypageComponent,
        PageTicketsGItemComponent,
        LayoutSidebarComponent,
        PortalTicketingCreateComponent,
        PageTicketsItemComponent,
        PagePostsComponent,
        PortalSeasonModalComponent,
        PageTicketsComponent,
        PageTicketDesignsComponent,
        PageAccessComponent,
        PageTicketsCreateComponent,
        PortalSeasonLoadingDefaultComponent,
        PageDashboardComponent,
        PageTicketsGComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalSeasonFormDropdownComponent,
        ComponentNavSidebarComponent,
        PagePostsItemComponent,
        PortalSeasonPaginationComponent,
        PageMembersComponent,
        PortalSeasonTreeComponent,
        PortalTicketingDetailComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }